import { render, staticRenderFns } from "./CounselIntro.vue?vue&type=template&id=053d0f48&scoped=true"
import script from "./CounselIntro.vue?vue&type=script&lang=js"
export * from "./CounselIntro.vue?vue&type=script&lang=js"
import style0 from "./CounselIntro.vue?vue&type=style&index=0&id=053d0f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d0f48",
  null
  
)

export default component.exports